const $ = require('jquery');
const ajax = require('../../../utils/ajax');
const util = require('../../../utils/util');

const DEFAULT_VALUES = {
    PAYMENT_CHEK_TIMEOUT: 5,
    WAITING_PAGE_MAX_TIME: 150
};

/**
 * Init adyen waiting page
 */
exports.init = function () {
    const orderNumber = $('.js-adyen-order-number').val();
    const orderToken = $('.js-adyen-order-token').val();
    const waitingPaymentCheckTimeout =
        parseInt(window.SitePreferences.ADYEN_WAITING_PAYMENT_CHEK_TIMEOUT) || DEFAULT_VALUES.PAYMENT_CHEK_TIMEOUT; // seconds
    const waitingPageMaxTime =
        parseInt(window.SitePreferences.ADYEN_WAITING_PAGE_MAX_TIME) || DEFAULT_VALUES.WAITING_PAGE_MAX_TIME; // seconds
    let failUrl = '';

    if (orderNumber) {
        let url = util.appendParamToURL(Urls.checkAdyenPaymentStatus, 'orderNumber', orderNumber);
        url = util.appendParamToURL(url, 'orderToken', orderToken);

        const startTime = new Date().getTime();
        const interval = setInterval(() => {
            if (new Date().getTime() - startTime > waitingPageMaxTime * 1000) {
                clearInterval(interval);
                window.location.href = failUrl;
                return;
            }

            ajax.getJson({
                url,
                /**
                 * @param {Object} data response data
                 */
                callback: data => {
                    if (data.redirectUrl) {
                        failUrl = data.redirectUrl;
                    }
                    if (data.redirect) {
                        clearInterval(interval);
                        window.location.href = data.redirectUrl;
                    }
                }
            });
        }, waitingPaymentCheckTimeout * 1000);
    }
};
